export default "__VITE_ASSET__CQTjKXIz__"